// @flow
import * as React from 'react'
import { getStaticSlugsPaths } from '../../../helpers/nextHelpers'
import type { SlugsStaticType } from '../../../helpers/nextHelpers'
import { withRouter, WithRouterProps } from 'next/router'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import {
  getThematicTagSlugs,
  getTheThematicTagPageProps
} from '../../../models/ThematicLandingPage'
import type { ThematicTagPagePropsType } from '../../../models/ThematicLandingPage'
import ReviewSection from '@components/ReviewSection'
import Spotlight from '@components/home/Spotlight'
import HeaderSection from '@components/HeaderSection'
import type { DeepLinkedCardsCarouselPropsType } from '../../../models/Discover'
import DeepLinkCardsCarousel from '@components/Discover/DeepLinkCardsCarousel'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { PopularTracksRow } from '@components/home/NewReleases/PopularTracksRow'
import HorizontalMediumTrackRow from '@components/Discover/HorizontalMediumTrackRow'
import { BenefitsSection } from '@components/BenefitsSection'
import { useSearchParams } from 'next/navigation'
import CharacterRow from '@components/shared/CharacterRow'

function ThematicTagPage (props: ThematicTagPagePropsType & { router: WithRouterProps }): React.Node {
  const searchParams = useSearchParams()
  const [showNewReleasesRow, setShowNewReleasesRow] = React.useState(true)
  const [showSubThemeRows, setShowSubThemeRows] = React.useState(true)
  const [showQuotes, setShowQuotes] = React.useState(true)
  const [showPopular, setShowPopular] = React.useState(true)
  React.useEffect((): void => {
    if (searchParams.get('n')) {
      setShowNewReleasesRow(false)
    }
    if (searchParams.get('sub')) {
      setShowSubThemeRows(false)
    }
    if (searchParams.get('q')) {
      setShowQuotes(false)
    }
    if (searchParams.get('p')) {
      setShowPopular(false)
    }
  }, [searchParams])
  return (
    <DiscoverLayout
      title={props.title}
      description={props.description}
      background
    >
      <HeaderSection
        title={props.title}
        description={props.description}
        description2={props.logLine}
        ctaText="try risk free"
      />
      <BenefitsSection />

      {(showNewReleasesRow && props.newReleasesRow) && <SectionDivider><HorizontalMediumTrackRow {...props.newReleasesRow}/></SectionDivider>}
      {showPopular && <PopularTracksRow themeId={props.id} title={`Popular Chapters`} description={`Popular chapters featuring ${props.title} on Dipsea`}/>}
      {props.characters.length && <SectionDivider><CharacterRow title={`Top Characters in ${props.title}`} displayType={'characterRow'} description={''} items={props.characters} cta={null}/></SectionDivider>}
      {showSubThemeRows && props.subThemeRows.map((item: DeepLinkedCardsCarouselPropsType, index: number): React.Node =>
        <SectionDivider key={`${props.id}-subthemerow-${index}`}><DeepLinkCardsCarousel {...item}/></SectionDivider>
      )}

      {showQuotes && <ReviewSection title={`WHAT LISTENERS ARE SAYING`} slides={props.quotesSection}/>}
      {props.spotlightSection && <Spotlight spotlightInfo={props.spotlightSection} showInline />}
    </DiscoverLayout>
  )
}
export default withRouter(ThematicTagPage)

type ContextType = {
  params: {
    slug: string
  }
}

export async function getStaticProps (
  context: ContextType
): Promise<{ props: ThematicTagPagePropsType }> {
  const props = await getTheThematicTagPageProps(context.params.slug)
  return { props }
}
export async function getStaticPaths (): Promise<SlugsStaticType> {
  const slugs = await getThematicTagSlugs()
  return getStaticSlugsPaths(slugs)
}

const SectionDivider = styled.div`
    width: 100%;
    margin-top: 32px;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
      margin-top: 48px;
    `}
    ${(props: any): string => config(props).media.lg`
      margin-top: 56px;
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
